import { inject, Service } from '@angular/core';
import { environment } from '../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { ArticlesItems, GetArticleParam, GetArticlesParam, GetRelatedCategoriesParam, GetRelatedTagsParam, GetRelatedAuthorsParam, ArticleWidgets, GetRelatedArticlesParam, RelatedArticleItems, FeaturedArticleItems, GetFeaturedParam, RecentArticleItems, Article } from '../interface/articles';
import { Observable } from 'rxjs';
import { CareerItems } from '../interface/careers';
import { Products, ProductItem } from '../interface/products';
import { SendMessageParam } from '../interface/contact';
import { Optimizations } from '../interface/optimization';

@Service()
export class Api {
    private api = environment.apiUrl;
    private http = inject(HttpClient);

    getOptimizeHome() : Observable<Optimizations> {
        return this.http.get<Optimizations>(`${this.api}/optimize/home`);
    }

    getOptimizeProducts() : Observable<Optimizations> {
        return this.http.get<Optimizations>(`${this.api}/optimize/products`);
    }

    getOptimizeCareers() : Observable<Optimizations> {
        return this.http.get<Optimizations>(`${this.api}/optimize/careers`);
    }

    getOptimizeContacts() : Observable<Optimizations> {
        return this.http.get<Optimizations>(`${this.api}/optimize/contacts`);
    }

    getProducts() : Observable<Products> {
        return this.http.get<Products>(`${this.api}/products`);
    }

    getProduct(param: string) : Observable<ProductItem> {
        return this.http.get<ProductItem>(`${this.api}/product/${param}`);
    }
    
    getArticles(param: GetArticlesParam) : Observable<Article> {
        return this.http.get<Article>(`${this.api}/articles/${param.limit}/${param.page}`);
    }

    getArticle(param: GetArticleParam) : Observable<ArticlesItems> {
        return this.http.get<ArticlesItems>(`${this.api}/article/${param.category}/${param.slug}`);
    }

    getLatestArticles() : Observable<ArticlesItems[]>{
        return this.http.get<ArticlesItems[]>(`${this.api}/latest`);
    }
    
    getFeaturedArticles(param: GetFeaturedParam) : Observable<Article>{
        return this.http.get<Article>(`${this.api}/featured/${param.limit}/${param.page}`);
    }

    getWidgetFeaturedArticles() : Observable<FeaturedArticleItems[]>{
        return this.http.get<FeaturedArticleItems[]>(`${this.api}/widgets/featured`);
    }

    getWidgetRelatedArticles(param: GetRelatedArticlesParam) : Observable<RelatedArticleItems[]> {
        return this.http.get<RelatedArticleItems[]>(`${this.api}/widgets/related/${param.category}/${param.exclude}`);
    }

    getWidgetRecentArticles() : Observable<RecentArticleItems[]>{
        return this.http.get<RecentArticleItems[]>(`${this.api}/widgets/recent`);
    }

    getCategoriesRelatedArticles(param: GetRelatedCategoriesParam) : Observable<Article>{
        return this.http.get<Article>(`${this.api}/categories/${param.slug}/${param.limit}/${param.page}`);
    }

    getTagsRelatedArticles(param: GetRelatedTagsParam) : Observable<Article> {
        return this.http.get<Article>(`${this.api}/tags/${param.slug}/${param.limit}/${param.page}`);
    }

    getAuthorsRelatedArticles(param: GetRelatedAuthorsParam) : Observable<Article> {
        return this.http.get<Article>(`${this.api}/authors/${param.slug}/${param.limit}/${param.page}`);
    }

    getWidgets() : Observable<ArticleWidgets>{
        return this.http.get<ArticleWidgets>(`${this.api}/widgets`);
    }

    getCareers() : Observable<CareerItems[]>{
        return this.http.get<CareerItems[]>(`${this.api}/careers`);
    }

    getCareer(param: string) : Observable<CareerItems> {
        return this.http.get<CareerItems>(`${this.api}/career/${param}`);
    }

    applyCareer(param: any) : Observable<any>{
        return this.http.post<any>(`${this.api}/apply`, param);
    };
    
    sendMessage(param: SendMessageParam) : Observable<any> {
        return this.http.post<any>(`${this.api}/send`, param);
    }
}
